import React, { useRef, useEffect, useState } from "react"
import { Box, Button, Flex } from "@chakra-ui/react"
import { useRoutes } from "@app/hooks/useRoutes"
import Link from "@app/components/Link"
import { useColorPreset } from "@app/hooks/useColorPreset"

type Props = {
  item?: GatsbyTypes.SanityNewHeaderMegaLinks
  selectedItem?: GatsbyTypes.SanityNewHeaderMegaFeaturedOrNewHeaderMegaLinks | null
  visible?: boolean
  activeHeaderIndex?: number | null
  handleItemClick?: (item: any, index: number) => void
  handleLinkClick?: () => void
}

const NavigationHeaderMegaLevel1: React.FC<Props> = ({
  item,
  selectedItem,
  visible,
  activeHeaderIndex,
  handleItemClick,
  handleLinkClick,
}) => {
  const itemsRef = useRef<Array<HTMLDivElement | null>>([])
  const [isFirstLoad, setIsFirstLoad] = useState(true)
  const { anyUrlResolver } = useRoutes()
  const { color: bgColor } = useColorPreset(selectedItem?.primaryColor)

  useEffect(() => {
    return () => {
      setIsFirstLoad(true)
    }
  }, [])

  return (
    <Flex
      bgColor={bgColor || "grey.lighter"}
      w="100%"
      maxHeight={15}
      display="flex"
      justifyContent="center"
      alignItems="center"
      pos="absolute"
      top={0}
      bottom={0}
    >
      {item?.items?.map((item: any, index: number) => {
        const resolvedLink = item._type === "newHeaderMegaLink" ? anyUrlResolver(item?.link) : null

        return (
          <Box key={index} ref={el => (itemsRef.current[index] = el)}>
            {/* isFirstLoad check required to shave off 0.01s from the font render to the correct colour on load only */}
            {item._type === "newHeaderMegaLink" ? (
              resolvedLink ? (
                <Button
                  as={Link}
                  to={resolvedLink?.url}
                  variant="headerItemLevel1"
                  size="small"
                  px={3}
                  zIndex={100}
                  pointerEvents={visible ? "auto" : "none"}
                  tabIndex={visible ? 0 : -1}
                  onClick={() => {
                    setIsFirstLoad(false)
                    handleLinkClick?.()
                  }}
                >
                  {item?.title}
                </Button>
              ) : null
            ) : (
              <Button
                variant={
                  isFirstLoad && index === activeHeaderIndex
                    ? "headerItemLevel1Active"
                    : item?.title === selectedItem?.title
                      ? "headerItemLevel1Active"
                      : "headerItemLevel1"
                }
                size="small"
                px={3}
                zIndex={100}
                fontWeight="bold"
                pointerEvents={visible ? "auto" : "none"}
                tabIndex={visible ? 0 : -1}
                onClick={e => {
                  e.stopPropagation()
                  setIsFirstLoad(false)
                  handleItemClick?.(item, index)
                }}
              >
                {item?.title}
              </Button>
            )}
          </Box>
        )
      })}
      {activeHeaderIndex !== null && (
        <Box
          position="absolute"
          zIndex={0}
          left={`${itemsRef.current[activeHeaderIndex ?? 0]?.offsetLeft}px`}
          w={`${itemsRef.current[activeHeaderIndex ?? 0]?.offsetWidth}px`}
          py="0"
          px="0"
          borderRadius={"24px"}
          bgColor="primary.white"
          h={9}
          transition={`all .2s ease-in-out`}
        />
      )}
    </Flex>
  )
}

export default React.memo(NavigationHeaderMegaLevel1)
